module.exports = __webpack_public_path__ + "img/p_sz_14.fafefcff.svg";